<div class="flex h-full flex-col bg-white">
  <!-- Image Gallery (responsive height based on screen size) -->
  <div
    class="relative z-0 h-[45%] [@media(max-height:550px)]:h-[30%] [@media(max-height:650px)]:h-[35%] [@media(max-height:800px)]:h-[40%]"
  >
    <app-property-gallery [index]="listingIndex()" [photos]="listing().photo_urls" />

    <!-- Force dots to stay at the top -->
    <div class="absolute left-1/2 top-3 z-20 -translate-x-1/2">
      <div class="swiper-pagination"></div>
    </div>

    @if (listing().in_auction) {
      <div
        class="absolute w-10 h-10 flex justify-center items-center right-3 top-3 z-20 rounded-max bg-black/70"
      >
        <svg-icon src="hammer.svg" class="shrink-0" svgClass="w-xl h-xl fill-white"></svg-icon>
      </div>
    }
  </div>

  <!-- Info & Feedback (overlay effect but pinned properly) -->
  <div
    class="relative z-10 flex h-[55%] flex-col justify-end rounded-t-3xl bg-white shadow-xl [@media(max-height:550px)]:h-[70%] [@media(max-height:650px)]:h-[65%] [@media(max-height:800px)]:h-[60%]"
  >
    <!-- Property Info -->
    <div class="flex-1 overflow-hidden p-4">
      <app-property-info [listing]="listing()" />
    </div>
  </div>
</div>
